import React from "react";
import MyPopup from "../MyPopup";
import type { PopupPosition } from "reactjs-popup/dist/types";

interface TooltipProps {
  content: React.ReactNode;
  children: React.ReactElement;
  position?: PopupPosition | PopupPosition[];
}

const Tooltip: React.FC<TooltipProps> = ({
  content,
  children,
  position = "bottom center",
}) => {
  return (
    <MyPopup trigger={children} on="hover" popUpDirection={position}>
      {() => (
        <div
          className="mail-inbox-tooltip-content mail-inbox-popup-content"
          style={{
            padding: "6px 10px",
            maxWidth: "400px",
            wordBreak: "break-word",
            whiteSpace: "pre-wrap",
            fontSize: "12px",
            borderRadius: "6px",
            backgroundColor: "#333",
            color: "#fff",
            zIndex: 10000,
            boxShadow: "0 2px 3px rgba(0, 0, 0, 0.2)",
          }}
        >
          {content}
        </div>
      )}
    </MyPopup>
  );
};

export default Tooltip;
